import {
    NODE_TYPE_GROUP,
    NODE_TYPE_QUESTION,
    NODE_TYPE_QUESTION_MULTIPLE,
    NODE_TYPE_CONTENT,
} from '../formNode/nodeTypes';

export const LOGIC_PROPERTY_REQUIRED = 'required';
export const LOGIC_PROPERTY_VISIBLE = 'visible';
export const LOGIC_PROPERTY_LIMIT = 'limit';

export const LOGIC_OPERAND_TYPE_FORM = 'form';
export const LOGIC_OPERAND_TYPE_GROUP = 'group';
export const LOGIC_OPERAND_TYPE_QUESTION = 'question';
export const LOGIC_OPERAND_TYPE_CONTENT = 'content';
export const LOGIC_OPERAND_TYPE_STRING = 'string';

export const LOGIC_OPERATOR_GREATER_THAN = 'greaterThan';
export const LOGIC_OPERATOR_LESS_THAN = 'lessThan';
export const LOGIC_OPERATOR_EQUALS = 'equals';
export const LOGIC_OPERATOR_CONTAINS = 'contains';
export const LOGIC_OPERATOR_NOT_CONTAINS = 'notContains';
export const LOGIC_OPERATOR_EQUALS_ANY = 'equalsAny';
export const LOGIC_OPERATOR_NOT_EQUALS_ANY = 'notEqualsAny';

export const LOGIC_OPERATOR_NOT_EQUALS = 'notEquals';
export const LOGIC_OPERATOR_REGEX = 'regex';
export const MULTIPLE_OPERATOR_SEPARATOR = '||';

export const EDITABLE_LOGIC_PROPERTIES = [LOGIC_PROPERTY_VISIBLE];

export const VALUE_TYPE_STRING = 'string';
export const VALUE_TYPE_BOOLEAN = 'boolean';
export const VALUE_TYPE_NUMBER = 'number';
export const VALUE_TYPE_QUESTION = NODE_TYPE_QUESTION;
export const VALUE_TYPE_GROUP = NODE_TYPE_GROUP;
export const VALUE_TYPE_CONTENT = NODE_TYPE_CONTENT;
export const VALUE_TYPE_REFERENCES = [
    VALUE_TYPE_QUESTION,
    VALUE_TYPE_GROUP,
    VALUE_TYPE_CONTENT,
    NODE_TYPE_QUESTION_MULTIPLE,
];

/**
 * Property defaults used when evaluating empty logic
 * @type {Object}
 */
export const PROPERTY_VALUE_DEFAULTS = {
    [LOGIC_PROPERTY_VISIBLE]: {
        defaultValue: true,
        defaultValueType: 'boolean',
    },
    [LOGIC_PROPERTY_REQUIRED]: {
        defaultValue: false,
        defaultValueType: 'boolean',
    },
    [LOGIC_PROPERTY_LIMIT]: {
        defaultValue: null,
        defaultValueType: 'string',
    },
};
